import {useEffect, useState} from 'react';

import {isInAppBrowser} from '@/shared/lib/env/isInAppBrowser';

export function useInAppBrowser() {
  const [inApp, setInApp] = useState(true);

  useEffect(() => {
    setInApp(isInAppBrowser(navigator.userAgent));
  }, []);

  return inApp;
}
